// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"b0d27914","425":"af53a300","510":"99e0de35","532":"414d80e7","633":"909b9302","634":"5a23c97c","922":"74c33f64","937":"2e187e55","972":"ef9ede80"}[chunkId] + ".chunk.js";
};